import store from '@/store'
import { gceSpecialistCAUserType } from '@/configs/constants'
import { canProcessGceStatement } from '@/configs/helpers'

let role = []

const canProcessGce = () => role.gceSpecialistCA && canProcessGceStatement(store.state.statement.statement)

export const initPermissions = () => {
  const profile = store.state.profile.profile
  role = {
    admin: profile.type_user === 'Admin',

    // ВЛ
    directorLaboratory: profile.type_user === 'Director laboratory',
    expertLaboratory: profile.type_user === 'Expert laboratory',
    sectionChiefLaboratory: profile.type_user === 'Section cheif laboratory',
    managerLaboratory: profile.type_user === 'Manager laboratory',
    gceSpecialist: profile.type_user === 'gce_specialist',
    universalRoleOfML: profile.type_user === 'universal_role_of_ml',

    // OC
    auditorCertification: profile.type_user === 'Auditor certification',
    gceSpecialistCA: profile.type_user === gceSpecialistCAUserType,
    directorCertification: profile.type_user === 'Director certification',
    universalRoleOfCA: profile.type_user === 'universal_role_of_ca',

    guestUser: profile.type_user === 'Guest'
  }
}

export const access = typeAccess => {
  if (typeAccess === 'public') {
    return true
  }

  switch (typeAccess) {
    // statement
    case 'statementView':
      return true
    case 'clientStatementView':
      return role.directorCertification || role.auditorCertification || role.universalRoleOfCA ||
        role.directorLaboratory || role.sectionChiefLaboratory || role.managerLaboratory || role.universalRoleOfML
    case 'statementCreate':
      return role.auditorCertification || role.universalRoleOfCA ||
        role.managerLaboratory || role.gceSpecialist || role.universalRoleOfML
    case 'useActionsClientStatement':
      return role.auditorCertification || role.universalRoleOfCA ||
        role.managerLaboratory || role.universalRoleOfML
    case 'clientTechnicalControlView':
      return role.directorLaboratory || role.sectionChiefLaboratory || role.managerLaboratory || role.universalRoleOfML
    case 'statementActionAuditorCertification':
      return role.auditorCertification || canProcessGce() || role.universalRoleOfCA
    case 'statementApproveForInspection':
      return role.auditorCertification || canProcessGce() || role.universalRoleOfCA
    case 'statementActionAuditorAndManager':
      return role.auditorCertification || role.universalRoleOfCA ||
        role.managerLaboratory || role.universalRoleOfML
    case 'statementActionDirectorCertification':
      return role.directorCertification || role.universalRoleOfCA
    case 'chooseLaboratoryOrCertificationAgency':
      return role.auditorCertification || canProcessGce() || role.universalRoleOfCA ||
        role.managerLaboratory || role.gceSpecialist || role.universalRoleOfML
    case 'chooseLaboratory':
      return role.auditorCertification || canProcessGce() || role.universalRoleOfCA
    case 'gceStatementActions':
      return role.gceSpecialist
    case 'setCategory':
      return role.auditorCertification || canProcessGce() || role.universalRoleOfCA ||
        role.managerLaboratory || role.universalRoleOfML
    case 'viewClientInfoList':
      return role.directorLaboratory || role.expertLaboratory || role.sectionChiefLaboratory ||
        role.gceSpecialist || role.universalRoleOfML
    case 'viewClientInfoCard':
      return role.directorCertification || role.auditorCertification || role.gceSpecialistCA || role.universalRoleOfCA ||
        role.managerLaboratory || role.expertLaboratory || role.gceSpecialist || role.universalRoleOfML
    case 'statementActionManagerLaboratory':
      return role.managerLaboratory || role.universalRoleOfML
    case 'useActionsClientTechnicalStatement':
      return role.managerLaboratory || role.universalRoleOfML
    case 'auditorCertification':
      return role.auditorCertification || role.universalRoleOfCA

    case 'technicalControlView' :
      return role.managerLaboratory || role.expertLaboratory ||
        role.sectionChiefLaboratory || role.directorLaboratory || role.universalRoleOfML
    case 'technicalControlStatementCreate' :
      return role.managerLaboratory || role.expertLaboratory || role.universalRoleOfML
    case 'technicalControlClientInfoCard':
      return role.directorLaboratory || role.managerLaboratory || role.universalRoleOfML
    case 'statementNewKtz':
      return role.directorCertification || role.auditorCertification || role.universalRoleOfCA
    case 'viewStatementApplicationType':
      return role.directorCertification || role.auditorCertification || role.gceSpecialistCA || role.universalRoleOfCA

    case 'gceSpecialist':
      return role.gceSpecialist
    case 'gceSpecialistCA':
      return role.gceSpecialistCA
    case 'gceStatementProcessing':
      return canProcessGce()
    case 'searchView':
      return !role.gceSpecialistCA

    //branch
    case 'measuringLaboratoryView':
      return role.directorLaboratory
    case 'branchView':
      return role.sectionChiefLaboratory || role.directorLaboratory

    case 'branchCreate':
      return role.directorLaboratory
    case 'branchUpdate':
      return role.sectionChiefLaboratory || role.directorLaboratory
    case 'changeBranchCertificationAgency':
      return role.sectionChiefLaboratory

    //inspection
    case 'inspectionCreate':
      return role.expertLaboratory || role.gceSpecialist || role.universalRoleOfML
    case 'technicalControlInspectionCreate':
      return role.expertLaboratory || role.universalRoleOfML
    case 'inspectionCard':
      return true
    case 'technicalControlInspectionCard':
      return !role.gceSpecialist && !role.gceSpecialistCA
    case 'canPrintInspectionDocument':
      return role.managerLaboratory || role.universalRoleOfML
    //role.directorLaboratory || role.auditorCertification ||
    // role.auditorCertification || role.directorCertification
    case 'uploadProofBase':
      return role.expertLaboratory || role.gceSpecialist || role.universalRoleOfML
    case 'viewCertificateDsbtTransfer':
      return role.directorCertification || role.auditorCertification || role.gceSpecialistCA || role.universalRoleOfCA ||
        role.directorLaboratory || role.expertLaboratory || role.sectionChiefLaboratory ||
        role.managerLaboratory || role.gceSpecialist || role.universalRoleOfML
    case 'transferCertificateToDsbt':
      return role.directorCertification || role.auditorCertification || role.gceSpecialistCA || role.universalRoleOfCA
    case 'revokeCertificateDsbtTransfer':
      return role.directorCertification

    //re-equipment
    case 'reEquipmentView':
      return role.expertLaboratory || role.universalRoleOfML

    //measurements
    case 'gasMeasurementView':
      return role.directorLaboratory || role.expertLaboratory || role.gceSpecialist || role.universalRoleOfML
    case 'measurementsView':
      return role.directorLaboratory || role.expertLaboratory || role.universalRoleOfML

    //settings
    case 'settings':
      return true
    case 'canAddAndRemoveKey':
      return role.directorLaboratory || role.expertLaboratory || role.sectionChiefLaboratory ||
        role.managerLaboratory || role.gceSpecialist || role.auditorCertification || role.directorCertification ||
        role.gceSpecialistCA || role.universalRoleOfML || role.universalRoleOfCA

    case 'auditorActions':
      return role.auditorCertification || role.universalRoleOfCA ||
        role.managerLaboratory || role.universalRoleOfML
    case 'directorCertificationActions':
      return role.directorCertification || role.universalRoleOfCA
    case 'directorLaboratoryActions':
      return role.directorLaboratory
    case 'sectionChiefLaboratoryActions':
      return role.sectionChiefLaboratory
    case 'expertLaboratoryActions':
      return role.expertLaboratory || role.gceSpecialist || role.universalRoleOfML

    // account OC
    case 'guestUser':
      return role.guestUser
    case 'viewContracts':
      return role.directorCertification || role.universalRoleOfCA

    // users
    case 'canCreateChief':
      return role.directorLaboratory
    case 'canCreateExpert':
      return role.directorLaboratory || role.sectionChiefLaboratory
    case 'canCreateGceSpecialist':
      return role.directorLaboratory || role.sectionChiefLaboratory
    case 'canCreateManager':
      return role.directorLaboratory || role.sectionChiefLaboratory
    case 'canResetUserPassword':
      return role.directorLaboratory || role.sectionChiefLaboratory

    // contract
    case 'canViewContract':
      return role.directorCertification || role.universalRoleOfCA || role.directorLaboratory
    case 'viewContractLabInfo':
      return role.directorCertification || role.universalRoleOfCA
    case 'viewContractOCInfo':
      return role.directorLaboratory

    case 'viewCharacteristic':
      return role.auditorCertification || role.directorCertification || role.universalRoleOfCA
    case 'setCharacteristic':
      return role.auditorCertification || role.universalRoleOfCA
    case 'statementManualView':
      return !role.gceSpecialist && !role.gceSpecialistCA
    case 'signCertificateManual':
      return role.directorCertification || role.universalRoleOfCA

    default:
      return false
  }

  // if (typeof typeAccess === 'object') {
  //   return typeAccess.some(p => profile.permissions.includes(p))
  // }
  // else return profile.permissions.includes(typeAccess)
}
